import "core-js/modules/es.parse-float";
import "core-js/modules/es.string.ends-with";
import _classCallCheck from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "E:\\Works\\Statistic\\stat-app\\node_modules\\@vue\\babel-preset-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";

/**
 * @license Copyright (c) 2003-2019, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module indent/indentcommandbehavior/indentusingoffset
 */

/**
 * The block indentation behavior that uses offsets to set indentation.
 *
 * @implements module:indent/indentblockcommand~IndentBehavior
 */
var IndentUsingOffset =
/*#__PURE__*/
function () {
  /**
   * Creates an instance of the indentation behavior.
   *
   * @param {Object} config
   * @param {String} config.direction The direction of indentation.
   * @param {Number} config.offset The offset of the next indentation step.
   * @param {String} config.unit Indentation unit.
   */
  function IndentUsingOffset(config) {
    _classCallCheck(this, IndentUsingOffset);

    /**
     * The direction of indentation.
     *
     * @type {Boolean}
     */
    this.isForward = config.direction === 'forward';
    /**
     * The offset of the next indentation step.
     *
     * @type {Number}
     */

    this.offset = config.offset;
    /**
     * Indentation unit.
     *
     * @type {String}
     */

    this.unit = config.unit;
  }
  /**
   * @inheritDoc
   */


  _createClass(IndentUsingOffset, [{
    key: "checkEnabled",
    value: function checkEnabled(indentAttributeValue) {
      var currentOffset = parseFloat(indentAttributeValue || 0); // The command is always enabled for forward indentation.

      return this.isForward || currentOffset > 0;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "getNextIndent",
    value: function getNextIndent(indentAttributeValue) {
      var currentOffset = parseFloat(indentAttributeValue || 0);
      var isSameUnit = !indentAttributeValue || indentAttributeValue.endsWith(this.unit);

      if (!isSameUnit) {
        return this.isForward ? this.offset + this.unit : undefined;
      }

      var nextOffset = this.isForward ? this.offset : -this.offset;
      var offsetToSet = currentOffset + nextOffset;
      return offsetToSet > 0 ? offsetToSet + this.unit : undefined;
    }
  }]);

  return IndentUsingOffset;
}();

export { IndentUsingOffset as default };